import API from './Api';

class GalleryAPI extends API {
    constructor() {
        super('/galleries');
    }

    findByFriendlyId(friendly_id, id){
        return this.axios.get(this.endpoint + `/find-by-friendly-id/${friendly_id}`);
    }

    isLogged(){
        return this.axios.get("/is-logged");
    }
}

export default GalleryAPI;

